// トレーニング履歴（日次）・比較用.
import * as React from 'react';
import { JS_VOID } from '../../utils/commonUtil';
import { MDate } from '../../utils/dateUtil';
import * as PropTypes from 'prop-types';
import * as TrainingConst from '../../constants/Training';
import { Training, TrainingMenu } from '../../constants/Training';

interface ReportProps extends React.Props<{}> {
  userId: string;
  history: any;

  trainingMenus: TrainingMenu[];
  className: string;
  isStartTerm: boolean;
  mDate: MDate;
}

class Report extends React.Component<ReportProps, {}> {
  userId: string;
  yearSelected: string;
  monthSelected: string;
  daySelected: string;
  mDate: MDate;

  componentWillMount() {
    this.userId = this.props.userId;
    this.mDate = this.props.mDate;

    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.daySelected = this.mDate.day;
  }

  static get contextTypes() {
    // 親のコンポーネントと橋渡しするcontext.
    return {
      // 左右.
      callbackParent: PropTypes.func,
      // ステート変更.
      changeState: PropTypes.func,
    };
  }

  componentWillReceiveProps() {
    // propsが変わった時に変化.
    this.mDate = this.props.mDate;
    this.refresh();
  }

  refresh = () => {
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.daySelected = this.mDate.day;
  }

  // 左をクリックしたときの処理.
  minusDaily = (yearSelected: string, monthSelected: string, daySelected: string) => {
    // 前日.
    const bkYearmonth: string = this.mDate.yearmonth;
    this.mDate.setPreDate();
    this.refresh();

    this.setState({date: this.mDate});

    // 変化があったとき.
    if (bkYearmonth !== this.mDate.yearmonth) {
      // 親contextのメソッド.
      this.context.callbackParent(this.props.isStartTerm, this.mDate.yearmonth);
    }
  }

  // 右をクリックしたときの処理.
  plusDaily = (yearSelected: string, monthSelected: string, daySelected: string) => {
    // 次の日.
    const bkYearmonth: string = this.mDate.yearmonth;
    this.mDate.setNextDate();
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.daySelected = this.mDate.day;
    this.refresh();

    this.setState({date: this.mDate});

    // 変化があったとき.
    if (bkYearmonth !== this.mDate.yearmonth) {
      // 親contextのメソッド.
      this.context.callbackParent(this.props.isStartTerm, this.mDate.yearmonth); 
    }
  }

  shouldComponentUpdate(nextProps: ReportProps, nextState: any): boolean {
    const propsDiff = nextProps === this.props;
    const stateDiff = nextState === this.state;
    return !(propsDiff && stateDiff);
  }

  // 終了をクリックしたときの処理.
  toFinishCompare = (userId: string) => {
    this.context.changeState(TrainingConst.DETAIL_STATE);
  }

  render() {
    // self.historyの中から今日の日付と一致するdictionaryを格納.
    let trainingOfSelectedDate: any[] = [];
    // '2017-03-03';
    let selectedDate: string = `${this.yearSelected}-${this.monthSelected}-${this.daySelected}`;
    // 存在例: 2017年08月06日
    // const selectedDate: string = `2017-08-06`;

    for (let key in this.props.history) {
      if (selectedDate === key) {
        trainingOfSelectedDate = this.props.history[key];
        break;
      }
    }

    return (
      <div className={this.props.className}>
        <div className="calendarHeader">
          <div className="dateArea">
            <div className="date">
              {this.monthSelected}
              <span>月</span>{this.daySelected}
              <span>日</span>
            </div>
            <div className="btn left">
              <a
                href={JS_VOID}
                onClick={event => this.minusDaily(this.yearSelected, this.monthSelected, this.daySelected)}
              />
            </div>
            <div className="btn right">
              <a
                href={JS_VOID}
                onClick={event => this.plusDaily(this.yearSelected, this.monthSelected, this.daySelected)}
              />
            </div>
          </div>
          { this.props.isStartTerm ?
            <div className="btnStyle05 mini">
              <a onClick={event => this.toFinishCompare(this.userId)}>終了</a>
            </div> : (null)
          }
        </div>
        <table className="tblStyle02">
          <colgroup>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
          </colgroup>
          <thead>
            <tr>
              <th scope="col">項目</th>
              <th scope="col">回数</th>
              <th scope="col">平均角度</th>
              <th scope="col" colSpan={2}>動作時間</th>
            </tr>
          </thead>
          <tbody>
            {
              // ある時だけ表示される.
              Object.keys(trainingOfSelectedDate).map((index: any) => {
                const training: Training = trainingOfSelectedDate[index];
                const key = `DailyTable${index}`;
                // Locomoの項目内にあるものだけ表示.
                if ((index >= TrainingConst.LOCOMO_MIN_NO && index <= TrainingConst.LOCOMO_MAX_NO) ||
                  (index >= TrainingConst.ADL_MIN_NO && index <= TrainingConst.ADL_MAX_NO)) {
                  return <tr key={key}>
                  {this.props.trainingMenus.map((trainingMenu: TrainingMenu, i: number) => {
                    if (trainingMenu.id === Number(index)) {
                      const headKey = `DailyTableHead${index}`;
                      return <th key={headKey}>{trainingMenu.name}</th>;
                    }

                    // 該当しないときはパス
                    return;
                  })}
                  <td>{training.count}</td>
                  <td>{training.average_angle}度</td>
                  <td>{training.average_duration}秒</td>
                  <td />
                </tr>;
                } else {
                  return (null);
                }
              }
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

// トレーニング履歴（日次）props
interface DailyHistoryCompareProps extends React.Props<{}> {
  userId: string;

  // response内容.
  trainingMenus: TrainingMenu[];
  startData: any;
  endData: any;

  // 親からの引き渡し用.
  startMDate: MDate;
  endMDate: MDate;

  type: TrainingConst.TYPE;
}

// トレーニング履歴（日次）.
export default class DailyHistoryCompare extends React.Component<DailyHistoryCompareProps, {}> {
  userId: string;

  startMDate: MDate;
  startYearSelected: string;
  startMonthSelected: string;
  startDaySelected: string;

  endMDate: MDate;
  endYearSelected: string;
  endMonthSelected: string;
  endDaySelected: string;

  static get contextTypes() {
    // 親のLocomoコンポーネントと橋渡しするcontext.
    return {callbackParent: PropTypes.func};
  }

  componentWillMount() {
    this.userId = this.props.userId;

    this.startMDate = this.props.startMDate;
    this.startYearSelected = this.startMDate.year;
    this.startMonthSelected = this.startMDate.month;
    this.startDaySelected = this.startMDate.day;

    this.endMDate = this.props.endMDate;
    this.endYearSelected = this.endMDate.year;
    this.endMonthSelected = this.endMDate.month;
    this.endDaySelected = this.endMDate.day;
  }

  shouldComponentUpdate(nextProps: DailyHistoryCompareProps, nextState: any): boolean {
    const propsDiff = nextProps === this.props;
    const stateDiff = nextState === this.state;
    return !(propsDiff && stateDiff);
  }

  render() {
    return (
      <section id="sec03">
        <h2 className="ttlStyle01">トレーニング履歴（日次）</h2>
        <div className="inner">
          <Report
            key={'startReport'}
            userId={this.userId}
            mDate={this.startMDate}
            className="startReport"
            trainingMenus={this.props.trainingMenus}
            history={this.props.startData}
            isStartTerm={true}
          />
          <Report
            key={'endReport'}
            userId={this.userId}
            mDate={this.endMDate}
            className="endReport"
            trainingMenus={this.props.trainingMenus}
            history={this.props.endData}
            isStartTerm={false}
          />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DailyHistoryCompare.tsx